import { withOrg } from './common/demoFilters';
export { filterByOrg, withOrg, DEF_JAM_ORG_ID, PERSONAL_ORG_ID } from './common/demoFilters';

import { DEF_JAM_ORG_ID, PERSONAL_ORG_ID } from './common/demoFilters';
import { deals as defJamDeals, quickAccessDeals as defJamQuickAccessDeals } from './def-jam/deals';
import { deals as personalDeals, quickAccessDeals as personalQuickAccessDeals } from './personal/deals';
import {
  calendarEvents as defJamCalendarEvents,
  calendarTasks as defJamCalendarTasks,
  calendarContacts as defJamCalendarContacts,
} from './def-jam/calendar';
import {
  calendarEvents as personalCalendarEvents,
  calendarTasks as personalCalendarTasks,
  calendarContacts as personalCalendarContacts,
} from './personal/calendar';
import {
  conversations as defJamConversations,
  notifications as defJamNotifications,
} from './def-jam/inbox';
import {
  conversations as personalConversations,
  notifications as personalNotifications,
} from './personal/inbox';
import {
  portfolioEntities as defJamPortfolioEntities,
  ENTITY_DEAL_MAP as defJamDealMap,
  ENTITY_TRANSACTIONS as defJamTransactions,
  ENTITY_ACTIVITY as defJamActivity,
  ENTITY_CONNECTED_ACCOUNTS as defJamConnectedAccounts,
} from './def-jam/portfolio';
import {
  portfolioEntities as personalPortfolioEntities,
  ENTITY_DEAL_MAP as personalDealMap,
  ENTITY_TRANSACTIONS as personalTransactions,
  ENTITY_ACTIVITY as personalActivity,
  ENTITY_CONNECTED_ACCOUNTS as personalConnectedAccounts,
} from './personal/portfolio';
import {
  mockDeliveryItems as defJamDeliveryItems,
  mockDetailData as defJamDeliveryDetailData,
  mockConnectedAccounts as defJamDeliveryAccounts,
  EQUALIQ_BALANCE_CENTS as defJamBalanceCents,
  PARTIES as defJamParties,
  emptyDetail as defJamEmptyDetail,
} from './def-jam/delivery';
import {
  mockDeliveryItems as personalDeliveryItems,
  mockDetailData as personalDeliveryDetailData,
  mockConnectedAccounts as personalDeliveryAccounts,
  EQUALIQ_BALANCE_CENTS as personalBalanceCents,
  PARTIES as personalParties,
  emptyDetail as personalEmptyDetail,
} from './personal/delivery';
import {
  vaultEqualiqRoot as defJamEqualiqRoot,
  vaultGdriveRoot as defJamGdriveRoot,
  vaultDropboxRoot as defJamDropboxRoot,
  vaultDealFilesMap as defJamDealFilesMap,
  vaultMailItems as defJamMailItems,
  vaultMeetingNotes as defJamMeetingNotes,
  vaultMessages as defJamMessages,
} from './def-jam/vault';
import {
  vaultEqualiqRoot as personalEqualiqRoot,
  vaultGdriveRoot as personalGdriveRoot,
  vaultDropboxRoot as personalDropboxRoot,
  vaultDealFilesMap as personalDealFilesMap,
  vaultMailItems as personalMailItems,
  vaultMeetingNotes as personalMeetingNotes,
  vaultMessages as personalMessages,
} from './personal/vault';
import {
  DEMO_DEAL_SUMMARY as defJamDealSummary,
  DEMO_DOCUMENT_VERSIONS as defJamDocumentVersions,
  KEY_DEAL_TERMS as defJamKeyTerms,
  KEY_TERM_CHART_DATA as defJamChartData,
  DEAL_BREAKDOWN as defJamBreakdown,
  EXAMPLE_ACTIVITY as defJamDealActivity,
} from './def-jam/dealPage';
import {
  DEMO_DEAL_SUMMARY as personalDealSummary,
  DEMO_DOCUMENT_VERSIONS as personalDocumentVersions,
  KEY_DEAL_TERMS as personalKeyTerms,
  KEY_TERM_CHART_DATA as personalChartData,
  DEAL_BREAKDOWN as personalBreakdown,
  EXAMPLE_ACTIVITY as personalDealActivity,
} from './dealPageData';

import type { ActivityEntry, ConnectedAccount, Transaction } from '@/types/portfolio.types';
import type {
  ConnectedAccount as DeliveryConnectedAccount,
  DeliveryItemDetailFields,
  Party,
} from '@/types/delivery-manager.types';
import type {
  MailItem,
  MeetingNoteItem,
  MessageItem,
  VaultFileItem,
  VaultFolderNode,
} from '@/types/vault.types';

export const ALL_DEALS = [
  ...withOrg(DEF_JAM_ORG_ID, defJamDeals),
  ...withOrg(PERSONAL_ORG_ID, personalDeals),
];

export const QUICK_ACCESS_DEALS: Record<
  string,
  Array<{ dealId: string; name: string; isPinned?: boolean }>
> = {
  [DEF_JAM_ORG_ID]: defJamQuickAccessDeals,
  [PERSONAL_ORG_ID]: personalQuickAccessDeals,
};

export const ALL_CALENDAR_EVENTS = [
  ...withOrg(DEF_JAM_ORG_ID, defJamCalendarEvents),
  ...withOrg(PERSONAL_ORG_ID, personalCalendarEvents),
];

export const ALL_CALENDAR_TASKS = [
  ...withOrg(DEF_JAM_ORG_ID, defJamCalendarTasks),
  ...withOrg(PERSONAL_ORG_ID, personalCalendarTasks),
];

export const ALL_CALENDAR_CONTACTS = [
  ...withOrg(DEF_JAM_ORG_ID, defJamCalendarContacts),
  ...withOrg(PERSONAL_ORG_ID, personalCalendarContacts),
];

export const ALL_CONVERSATIONS = [
  ...withOrg(DEF_JAM_ORG_ID, defJamConversations),
  ...withOrg(PERSONAL_ORG_ID, personalConversations),
];

export const ALL_NOTIFICATIONS = [
  ...withOrg(DEF_JAM_ORG_ID, defJamNotifications),
  ...withOrg(PERSONAL_ORG_ID, personalNotifications),
];

export const ALL_PORTFOLIO_ENTITIES = [
  ...withOrg(DEF_JAM_ORG_ID, defJamPortfolioEntities),
  ...withOrg(PERSONAL_ORG_ID, personalPortfolioEntities),
];

export const PORTFOLIO_DEAL_MAPS: Record<string, Record<string, string[]>> = {
  [DEF_JAM_ORG_ID]: defJamDealMap,
  [PERSONAL_ORG_ID]: personalDealMap,
};

export const PORTFOLIO_TRANSACTIONS: Record<string, Record<string, Transaction[]>> = {
  [DEF_JAM_ORG_ID]: defJamTransactions,
  [PERSONAL_ORG_ID]: personalTransactions,
};

export const PORTFOLIO_ACTIVITY: Record<string, Record<string, ActivityEntry[]>> = {
  [DEF_JAM_ORG_ID]: defJamActivity,
  [PERSONAL_ORG_ID]: personalActivity,
};

export const PORTFOLIO_CONNECTED_ACCOUNTS: Record<string, Record<string, ConnectedAccount[]>> = {
  [DEF_JAM_ORG_ID]: defJamConnectedAccounts,
  [PERSONAL_ORG_ID]: personalConnectedAccounts,
};

export const ALL_DELIVERY_ITEMS = [
  ...withOrg(DEF_JAM_ORG_ID, defJamDeliveryItems),
  ...withOrg(PERSONAL_ORG_ID, personalDeliveryItems),
];

export const DELIVERY_DETAIL_DATA: Record<
  string,
  Record<string, DeliveryItemDetailFields>
> = {
  [DEF_JAM_ORG_ID]: defJamDeliveryDetailData,
  [PERSONAL_ORG_ID]: personalDeliveryDetailData,
};

export const DELIVERY_CONNECTED_ACCOUNTS: Record<string, DeliveryConnectedAccount[]> = {
  [DEF_JAM_ORG_ID]: defJamDeliveryAccounts,
  [PERSONAL_ORG_ID]: personalDeliveryAccounts,
};

export const DELIVERY_BALANCE: Record<string, number> = {
  [DEF_JAM_ORG_ID]: defJamBalanceCents,
  [PERSONAL_ORG_ID]: personalBalanceCents,
};

export const DELIVERY_PARTIES: Record<string, Record<string, Party>> = {
  [DEF_JAM_ORG_ID]: defJamParties,
  [PERSONAL_ORG_ID]: personalParties,
};

export const DELIVERY_EMPTY_DETAIL: Record<string, DeliveryItemDetailFields> = {
  [DEF_JAM_ORG_ID]: defJamEmptyDetail,
  [PERSONAL_ORG_ID]: personalEmptyDetail,
};

interface VaultTreeSet {
  equaliq: VaultFolderNode;
  gdrive: VaultFolderNode;
  dropbox: VaultFolderNode;
  dealFilesMap: Record<string, VaultFileItem[]>;
  mailItems: MailItem[];
  meetingNotes: MeetingNoteItem[];
  messages: MessageItem[];
}

export const VAULT_TREES: Record<string, VaultTreeSet> = {
  [DEF_JAM_ORG_ID]: {
    equaliq: defJamEqualiqRoot,
    gdrive: defJamGdriveRoot,
    dropbox: defJamDropboxRoot,
    dealFilesMap: defJamDealFilesMap,
    mailItems: defJamMailItems,
    meetingNotes: defJamMeetingNotes,
    messages: defJamMessages,
  },
  [PERSONAL_ORG_ID]: {
    equaliq: personalEqualiqRoot,
    gdrive: personalGdriveRoot,
    dropbox: personalDropboxRoot,
    dealFilesMap: personalDealFilesMap,
    mailItems: personalMailItems,
    meetingNotes: personalMeetingNotes,
    messages: personalMessages,
  },
};

export const DEAL_PAGE_DATA: Record<
  string,
  {
    summary: typeof defJamDealSummary;
    documentVersions: typeof defJamDocumentVersions;
    keyTerms: typeof defJamKeyTerms;
    chartData: typeof defJamChartData;
    breakdown: typeof defJamBreakdown;
    activity: Array<{
      id: string;
      user: string;
      action: string;
      content: string;
      timestamp: string;
      avatar: string | undefined;
    }>;
  }
> = {
  [DEF_JAM_ORG_ID]: {
    summary: defJamDealSummary,
    documentVersions: defJamDocumentVersions,
    keyTerms: defJamKeyTerms,
    chartData: defJamChartData,
    breakdown: defJamBreakdown,
    activity: defJamDealActivity,
  },
  [PERSONAL_ORG_ID]: {
    summary: personalDealSummary,
    documentVersions: personalDocumentVersions,
    keyTerms: personalKeyTerms,
    chartData: personalChartData,
    breakdown: personalBreakdown,
    activity: personalDealActivity,
  },
};
